export default {
  data: () => ({
    prevRoute: null,
    returnPath: null
  }),
  methods: {
    dismiss() {
      let route = this.returnPath ? this.returnPath : this.prevRoute ? this.prevRoute : { path: '/' }
      this.$router.push(route)
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  }
}
